import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';
import { IKnmErknmFormJudgment } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormJudgment';
import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';

import { DecisionJudgmentModalElement } from './DecisionJudgmentModalElement';
import styles from './Judgment.module.scss';

interface ITemplateAddJudgmentModalProps {
  formRef: IDecisionFormRef | undefined;
  visible: boolean;
  modalType: 'organization' | 'decision' | 'judgments';
  judgmentItemName?: string;
  judgmentItemSubjectDataItemName?: string;
  onSave: () => void;
  onCancel: () => void;
  organization?: IDecisionOrganizationForm | undefined;
  judgements?: IKnmErknmFormJudgment[] | undefined;
}

export const AddJudgmentModal = ({
  formRef,
  visible,
  modalType,
  judgmentItemName,
  judgmentItemSubjectDataItemName,
  onSave,
  onCancel,
  organization,
  judgements,
}: ITemplateAddJudgmentModalProps) => {
  const modalTitle = () => {
    if (modalType === 'organization') {
      return 'Выбор контролируемого лица';
    }
    if (modalType === 'decision') {
      return 'Выбор решения';
    }

    return 'Выбор судебного решения';
  };
  const modalSubTitle = () => {
    if (modalType === 'organization') {
      return 'Выберите контролируемое лицо, в отношении которого принято решение';
    }
    if (modalType === 'decision') {
      return 'Выберите решение в рамках паспорта решения, которое было отменено или отменено частично';
    }

    return 'Выберите судебное решение в рамках паспорта решения, которое было отменено или отменено частично';
  };

  return (
    <Modal modalBodyClassName={styles.ModalBody} visible={visible} onClose={onCancel}>
      <ModalHeader title={modalTitle()} sizeText="medium" color="black" />
      <ModalBody size="content" border="bottom">
        <h4 className={styles.Text}>{modalSubTitle()}</h4>
        {modalType === 'organization' && organization && (
          <div>
            <DecisionJudgmentModalElement
              formRef={formRef}
              key={organization.guid}
              modalType={modalType}
              judgmentItemName={judgmentItemName}
              organizationToSelect={organization}
            />
          </div>
        )}
        {modalType === 'organization' && !organization && (
          <div className={styles.EmptyModalText}>
            Для заполнения данных о контролируемом лице, в отношении которого принято решение, необходимо создать запись
            о контролируемом лице и сохранить её в записи паспорта решения
          </div>
        )}
        {modalType === 'decision' &&
          organization?.resultDecisions &&
          organization?.resultDecisions.map(decision => (
            <div key={decision.guid}>
              <DecisionJudgmentModalElement
                formRef={formRef}
                key={decision.guid}
                modalType={modalType}
                judgmentItemName={judgmentItemName}
                judgmentItemSubjectDataItemName={judgmentItemSubjectDataItemName}
                organizationToSelect={organization}
                decision={decision}
              />
            </div>
          ))}
        {modalType === 'decision' && organization?.resultDecisions?.length && (
          <div className={styles.EmptyModalText}>
            Для отображения решения необходимо создать и сохранить их в записи паспорта решения по выбранному в судебном
            решении контролируемому лицу
          </div>
        )}
        {modalType === 'judgments' && judgements && (
          <div>
            {judgements.map(judgment => (
              <DecisionJudgmentModalElement
                formRef={formRef}
                key={judgment.guid}
                modalType={modalType}
                judgmentItemName={judgmentItemName}
                judgmentToSelect={judgment}
              />
            ))}
          </div>
        )}
        {modalType === 'judgments' && !judgements?.length && (
          <div className={styles.EmptyModalText}>
            Для отображения судебного решения необходимо создать запись судебного решения и сохранить её в записи
            паспорта решения
          </div>
        )}
      </ModalBody>
      <ModalActions>
        <Button
          text="Сохранить"
          id="saveButton"
          size="medium"
          disabled={!organization && !judgements}
          onClick={onSave}
        />
        <Button text="Закрыть" size="medium" onClick={onCancel} />
      </ModalActions>
    </Modal>
  );
};
